import { Component, OnChanges, SimpleChanges, ChangeDetectionStrategy, input, output } from '@angular/core';
import {UnitRatingRequest} from '../../model/unit-rating-request';
import {UnitConversionUtils} from '../../configurator/unit-conversion-utils';
import { ScheduleLinePerformanceCoilInputComponent } from '../schedule-line-performance-coil-input/schedule-line-performance-coil-input.component';

import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-schedule-line-performance-input',
    templateUrl: './schedule-line-performance-input.component.html',
    styleUrls: ['./schedule-line-performance-input.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, ScheduleLinePerformanceCoilInputComponent]
})
export class ScheduleLinePerformanceInputComponent implements OnChanges {

  readonly requestInput = input.required<UnitRatingRequest>({ alias: 'request' });
  readonly isAirHandler = input.required<boolean>();
  readonly selectionChange = output<void>();
  metricInput!: string;
  private primaryMetricUpdated: any;
  private secondaryMetricUpdated: any;
  private eHeatMetricUpdated: any;

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.metricInput = this.requestInput().IsMetricInput ? 'True' : 'False';
  }

  private convertEsp(): number {
    return isNaN(this.requestInput().ExternalStaticPressure)
      ? undefined! : this.round(UnitConversionUtils.convertStaticPressure(this.requestInput().ExternalStaticPressure, this.requestInput().IsMetricInput), 3);
  }

  private convertAirflow(): number {
    return isNaN(this.requestInput().Airflow)
      ? undefined! : this.round(UnitConversionUtils.convertAirflow(this.requestInput().Airflow, this.requestInput().IsMetricInput), 3);
  }

  private convertAltitude(): number {
    return isNaN(this.requestInput().Altitude)
      ? undefined! : this.round(UnitConversionUtils.convertAltitudeValue(this.requestInput().Altitude, this.requestInput().IsMetricInput), 3);
  }

  private round(value: string, digits: number): number {
    const numericValue = +value;
    const roundedValue = numericValue.toFixed(digits);
    return +roundedValue;
  }

  metricInputChanged(): void {
    this.primaryMetricUpdated = false;
    this.secondaryMetricUpdated = false;
    this.eHeatMetricUpdated = false;
    this.requestInput().IsMetricInput = 'True' === this.metricInput;
    this.requestInput().Altitude = this.convertAltitude();
    this.requestInput().Airflow = this.convertAirflow();
    this.requestInput().ExternalStaticPressure = this.convertEsp();
  }

  primaryMetricInputUpdated(): void {
    this.primaryMetricUpdated = true;
    this.handleCoilMetricUpdatedResponse();
  }

  private handleCoilMetricUpdatedResponse(): void {
    let readyToUpdate: boolean = false;
    if (this.requestInput().PrimaryCoilRequest) {
      readyToUpdate = this.primaryMetricUpdated;
    }
    if (this.requestInput().SecondaryCoilRequest) {
      readyToUpdate = this.secondaryMetricUpdated;
    }
    if (this.requestInput().ElectricHeatRequest) {
      readyToUpdate = this.eHeatMetricUpdated;
    }
    if (readyToUpdate) {
      this.inputChanged();
    }
  }

  secondaryMetricInputUpdated(): void {
    this.secondaryMetricUpdated = true;
    this.handleCoilMetricUpdatedResponse();
  }

  eHeatMetricInputUpdated(): void {
    this.eHeatMetricUpdated = true;
    this.handleCoilMetricUpdatedResponse();
  }

  inputChanged(): void {
    this.selectionChange.emit();
  }

  getEspUnits(): string {
    return UnitConversionUtils.getEspUnits(this.requestInput().IsMetricInput);
  }

  getAirflowUnits(): string {
    return UnitConversionUtils.getAirflowUnits(this.requestInput().IsMetricInput);
  }

  getLengthUnits(): string {
    return UnitConversionUtils.getLengthUnits(this.requestInput().IsMetricInput);
  }

}
